import './index.css'

const ImageItem = props => {
  const {details, onClickImg} = props

  const {id, thumbnailUrl} = details

  const onClickHandler = () => {
    onClickImg(id)
  }

  return (
    <li className="thumbnail-item">
      <button
        type="button"
        className="thumbnail-image-button"
        onClick={onClickHandler}
      >
        <img src={thumbnailUrl} className="thumbnail-image" alt="thumbnail" />
      </button>
    </li>
  )
}

export default ImageItem
